import { useNavigate } from 'react-router-dom';

import { Menu, rem } from '@mantine/core';

import { AppRoutes } from '@/router/routes.ts';

import { IconIdBadge2 } from '@tabler/icons-react';

export const ScudMappingSection = () => {
	const navigate = useNavigate();

	return (
		<Menu.Item
			fz="md"
			fw={600}
			leftSection={<IconIdBadge2 style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
			onClick={() => navigate(AppRoutes.ScudMapping)}
		>
			Сопоставление пропусков СКУД
		</Menu.Item>
	);
};
